import { Stack, styled } from '@mui/material'
import { ActionButton } from '../../components/Buttons/ActionButton'

export const Max = styled('div')`
  line-height: 24px;
  color: ${(props) => props.theme.color.text90};
  padding: 0 12px;
  cursor: pointer;
  background: ${(props) => props.theme.color.primary10};
  border-radius: 2px;
`
export const Available = styled('div')`
  display: flex;
  justify-content: space-between;
  text-align: right;
  font-size: 16px;
  line-height: 16px;
  span {
    color: #76809d;
  }
  b {
    color: #303648;
    font-weight: 500;
  }
`
export const HeaderTip = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(149, 164, 173, 1);
`
export const StyledDepositButton = styled(ActionButton)`
  height: 48px;
  border-radius: 24px;
`
export const FromTip = styled('div')`
  color: rgba(149, 164, 173, 1);
  font-size: 14px;
`
